interface RolePermission {
  path: string;
  permission: {
    Ops: boolean;
    Admin: boolean;
    Creator: boolean;
    Editor: boolean;
    Moderator: boolean;
    Attendee: boolean;
  };
  scope?: string;
}

interface PathConfig {
  home: RolePermission;
  profilePlan: RolePermission;
  profileTeam: RolePermission;
  profileRewards: RolePermission;
  profileIntegrations: RolePermission;
  profileScripts: RolePermission;
  profileDomains: RolePermission;
  profileEdit: RolePermission;
  newEWebinar: RolePermission;
  shareEwebinar: RolePermission;
  enableRelay: RolePermission;
  duplicateEwebinar: RolePermission;
  publishEwebinar: RolePermission;
  unpublishEwebinar: RolePermission;
  deleteEwebinar: RolePermission;
  discardChangesEwebinar: RolePermission;
  portalWebinarSchedule: RolePermission;
  portalWebinarScheduleSet: RolePermission;
  portalWebinarScheduleSettings: RolePermission;
  portalWebinarChatSettings: RolePermission;
  portalWebinarRegistration: RolePermission;
  portalWebinarRegistrationPage: RolePermission;
  portalWebinarRegistrationForm: RolePermission;
  portalWebinarRegistrationThankyou: RolePermission;
  portalWebinarRegistrationSettings: RolePermission;
  portalWebinarNotifications: RolePermission;
  portalWebinarInteractions: RolePermission;
  portalWebinarInteractionsDetail: RolePermission;
  portalWebinarSettings: RolePermission;
  portalWebinarSettingsSharing: RolePermission;
  portalWebinarSettingsDisplay: RolePermission;
  portalWebinarSettingsChat: RolePermission;
  portalDashboardInteractions: RolePermission;
  portalDashboardAnalytics: RolePermission;
  portalDashboardRegistrants: RolePermission;
  portalDashboardChat: RolePermission;
  opsTeams: RolePermission;
  opsHome: RolePermission;
}

interface PathParams {
  ewebinarId?: string;
  setId?: string;
  interactionId?: string;
}

// eslint-disable-next-line @typescript-eslint/no-var-requires
const rolesPermissionsMatrix: PathConfig = require('./rolesPermissionsMatrix.json');

const getRoute = (path: string, params: PathParams): string => {
  return path.replace(/:[a-zA-Z?]+/g, (match) => {
    if (match === ':ewebinarId') return params.ewebinarId || match;
    if (match === ':setId') return params.setId || match;
    if (match === ':interactionId') return params.interactionId || match;
    return match;
  });
};

export { RolePermission, PathConfig, getRoute, rolesPermissionsMatrix };
